import { createSlice } from "@reduxjs/toolkit"
import {AUTOMATED_SEARCH_PANEL_VIEW, automatedSearchPanelViewSlice} from "./automatedSearchViewSlice"


export const automatedSearchPanelNavSlice = createSlice({
	name: "automatedSearchPanelNav",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		setAutomatedSearchPanelNav: (state, action) => {
			const {search, workspaceId} = action.payload
			state.byWorkspace[workspaceId] = search
		},
		resetAutomateSearchPanelNav: (state, action) => {
			delete state.byWorkspace[action.payload]
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(
				automatedSearchPanelViewSlice.actions.setSelectedSearch,
				automatedSearchPanelNavSlice.caseReducers.setAutomatedSearchPanelNav
			)
			.addCase(
				automatedSearchPanelViewSlice.actions.setAutomatedSearchPanelView,
				(state, action) => {
					const {view, workspaceId} = action.payload
					if(view !== AUTOMATED_SEARCH_PANEL_VIEW.ARTICLE_LIST) {
						automatedSearchPanelNavSlice.caseReducers.resetAutomateSearchPanelNav(state, {payload: workspaceId})
					}
				}
			)
	}
})

export const selectAutomatedSearchPanelNav = (state, workspaceId) =>
	state.automatedSearchPanelNav.byWorkspace?.[workspaceId] ?? null

export default automatedSearchPanelNavSlice.reducer